import React, { useMemo } from "react";

import { copy } from "shared/assets";
import { Button, CloseButton, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { slideInFromTop } from "shared/styles/constants";
import { ITheme } from "shared/types";
import { useBreakpoint } from "shared/utils";
import { StyledTableProps, StyledOpenRow, OpenRowCell, OpenRowContent } from "../styles";

interface OpenRowProps extends StyledTableProps {
  colSpan: number;
  handleClose: () => void;
}

export const OpenRow: React.FC<OpenRowProps> = ({ children, colSpan, handleClose, ...rest }) => {
  const isMobile = useBreakpoint();

  const content = useMemo(
    () => (
      <Spacer size="m">
        {children}
        <Button onClick={handleClose} theme={ITheme.secondary} size="s">
          {copy.actions.close}
        </Button>
      </Spacer>
    ),
    [children, handleClose]
  );

  if (isMobile) return <Modal handleClose={handleClose}>{content}</Modal>;

  return (
    <StyledOpenRow {...slideInFromTop} {...rest}>
      <OpenRowCell colSpan={colSpan}>
        <OpenRowContent>
          <CloseButton filled={true} onClick={handleClose} theme={ITheme.tertiary} />
          {content}
        </OpenRowContent>
      </OpenRowCell>
    </StyledOpenRow>
  );
};
